import { Observable, of } from 'rxjs';

export abstract class AbstractBaseService {
    abstract show(id: number, includes?: string[]): Observable<any>;
    abstract index(page?: number, perPage?: number, filters?: any, includes?: string[], sorts?: any): Observable<any>;
    abstract store(payload: any): Observable<any>;
    abstract destroy(id: number): Observable<any>;
    abstract update(id: number, payload: any): Observable<any>;
    customSearch(page?: number, perPage?: number, filters?: any, includes?: string[], sorts?: any): Observable<any> {
        return of({});
    }
}
